import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function useOnRouteChange(callBackFn) {
	const { pathname } = useLocation();
	useEffect(callBackFn, [pathname]);
}

export default useOnRouteChange;
